import { ACTIVITY_MODE, ANONYMIZE_NAMES, REAL_ACTIVITY_KEY } from "../config/activityConfig";

// Sample/demo activity — replace or empty this list when switching to real mode.
const SAMPLE_ACTIVITIES = [
  { name: "Rahul", location: "Mumbai", activity: "requested a website plan", timestamp: "5 min ago" },
  { name: null, label: "A business owner", location: "Delhi", activity: "enquired about a new business website", timestamp: "8 min ago" },
  { name: "Priya", location: "Noida", activity: "requested an SEO-friendly website", timestamp: "12 min ago" },
  { name: null, label: "A startup founder", location: "Bangalore", activity: "asked about website development", timestamp: "16 min ago" },
  { name: "Amit", location: "Gurgaon", activity: "enquired about website redesign", timestamp: "21 min ago" },
  { name: null, label: "A business", location: "Pune", activity: "requested a B2B lead generation website", timestamp: "28 min ago" },
  { name: "Rohan", location: "Mumbai", activity: "asked about monthly SEO growth", timestamp: "34 min ago" },
  { name: null, label: "A company", location: "Delhi", activity: "requested a website consultation", timestamp: "41 min ago" },
  { name: "Sneha", location: "Noida", activity: "enquired about a landing page", timestamp: "47 min ago" },
  { name: null, label: "A business owner", location: "Hyderabad", activity: "requested a free website plan", timestamp: "55 min ago" },
  { name: "Karan", location: "Ahmedabad", activity: "enquired about improving an existing website", timestamp: "1 hour ago" },
  { name: null, label: "A growing business", location: "Jaipur", activity: "requested information about SEO and lead generation", timestamp: "1 hour ago" },
  { name: null, label: "A business owner", location: "Chandigarh", activity: "asked about a premium business website", timestamp: "2 hours ago" },
  { name: "Nikhil", location: "Mumbai", activity: "requested a website redesign plan", timestamp: "2 hours ago" },
  { name: null, label: "A company", location: "Delhi", activity: "enquired about generating more B2B leads", timestamp: "3 hours ago" },
];

const anonymizeName = (name) =>
  name && ANONYMIZE_NAMES ? `${name[0]}${"*".repeat(Math.max(name.length - 1, 2))}` : name;

const normalize = (a) => ({
  displayName: a.name
    ? `${anonymizeName(a.name)} from ${a.location}`
    : `${a.label || "A business owner"} from ${a.location}`,
  location: a.location,
  activity: a.activity,
  timestamp: a.timestamp,
  source: a.source || "sample",
});

export const getActivities = () => {
  if (ACTIVITY_MODE === "real") {
    try {
      return JSON.parse(localStorage.getItem(REAL_ACTIVITY_KEY) || "[]").map(normalize);
    } catch {
      return [];
    }
  }
  return SAMPLE_ACTIVITIES.map(normalize);
};

const REQUIREMENT_ACTIVITY = {
  "New Website": "requested a new business website",
  "Website Redesign": "requested a website redesign plan",
  "B2B Lead Generation": "enquired about generating more B2B leads",
  SEO: "requested an SEO consultation",
  "Local SEO": "enquired about a local SEO website",
  "Landing Page": "enquired about a landing page",
  "Website + Monthly Growth": "asked about monthly SEO growth",
  "Not Sure Yet": "requested a free website plan",
};

// Privacy-friendly: stores only first name + city + requirement. No phone/email/business name.
export const recordRealActivity = (form) => {
  try {
    const firstName = (form.name || "").trim().split(" ")[0] || null;
    const city = (form.city || "").trim();
    const entry = {
      name: city ? firstName : null,
      label: firstName ? null : "A business owner",
      location: city || (firstName ? "India" : null),
      activity: REQUIREMENT_ACTIVITY[form.requirement] || "requested a website plan",
      timestamp: "Just now",
      source: "real",
    };
    if (!entry.location) return;
    const list = JSON.parse(localStorage.getItem(REAL_ACTIVITY_KEY) || "[]");
    list.unshift(entry);
    localStorage.setItem(REAL_ACTIVITY_KEY, JSON.stringify(list.slice(0, 20)));
  } catch {
    /* storage unavailable */
  }
};
